import classes from "./SimilarProduct.module.css";
import { useNavigate } from "react-router-dom";

function SimilarProduct(props) {
	// for navigation
	const navigate = useNavigate("");

	//for routing to product info
	const visitProductPage = () => {
		navigate("/products/" + props.id);
	};

	return (
		<div className={classes.card} onClick={visitProductPage}>
			<div
				style={{ backgroundImage: `url("${props.itemImg[0]}")` }}
				className={classes.image}
			></div>
			<div className={classes.name}>{props.itemName}</div>
			<div className={classes.price}>${props.itemPrice}</div>
		</div>
	);
}
export default SimilarProduct;
